import { Box, TextField, MenuItem, Button, Typography } from "@mui/material";

export default function ActivityEditForm({ 
  empresaNombre,
  empresa,
  form,
  onChange,
  onSubmit,
  selectedActivity,
  opcionesPorOperacion,
  onOpenStock,
}) {
  const getLabel = () => {
    switch (form.operation) {
      case "Pagos":
        return "Tipo de pagos";
      case "Compras":
        return "Tipo de compras";
      case "Ingresos":
        return "Tipo de ingresos";
      default:
        return "Seleccione una operación";
    }
  };

  const empresaData = opcionesPorOperacion[empresaNombre] ?? opcionesPorOperacion["EmpresaPrueba"];
  const opciones = empresaData?.[0]?.[form.operation] ?? [];

  if (!selectedActivity) {
    return <Typography>Seleccione una actividad para editarla</Typography>;
  }

  return (
    <Box sx={{ mt: 0 }}>
      <Typography variant="h6">Editar Actividad</Typography>

      <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
        <TextField
          fullWidth
          select
          label="Operación"
          name="operation"
          value={form.operation}
          onChange={onChange}
        >
          <MenuItem value="Pagos">Pagos</MenuItem>
          <MenuItem value="Compras">Compras</MenuItem>
          <MenuItem value="Ingresos">Ingresos</MenuItem>
        </TextField>

        {form.operation === "Compras" && empresa?.stock && (
          <Button
            variant="outlined"
            size="small"
            onClick={onOpenStock}
          >
            Agregar a stock
          </Button>
        )}
      </Box>

      {form.operation && opciones.length > 0 ? (
        <TextField
          fullWidth
          select
          label={getLabel()}
          name="title"
          value={form.title}
          onChange={onChange}
          sx={{ my: 1 }}
        >
          {opciones.map((op, index) => (
            <MenuItem key={index} value={op}>
              {op}
            </MenuItem>
          ))}
        </TextField>
      ) : (
        <TextField
          fullWidth
          select
          label="Seleccione una operación"
          name="title"
          value=""
          disabled
          sx={{ my: 1 }}
        >
          <MenuItem value="" disabled>
            -
          </MenuItem>
        </TextField>
      )}


      {form.operation && (
        <TextField
          label="Descripción (opcional)"
          fullWidth
          multiline
          minRows={2}
          maxRows={2}
          name="description"
          value={form.description}
          onChange={onChange}
          sx={{ mb: 1 }}
        />
      )}

      <TextField
        fullWidth
        label="Monto"
        name="amount"
        type="number"
        value={form.amount}
        onChange={onChange}
      />

      <Button
        variant="contained"
        color="success"
        onClick={onSubmit}
        fullWidth
        sx={{ mt: 1 }}
      >
        Guardar cambios
      </Button>
    </Box>
  );
}
